import { Phone, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getInitials } from 'utils/helpers';
import { PORTAL_ROUTES } from 'utils/constants';
import { Skeleton } from 'react-daisyui';

function Header({ conversation }) {
  const { title, patient_number } = conversation?.attributes || {};

  if (!conversation)
    return (
      <div className="flex items-center gap-3 px-4 py-3 border-b border-base-200 bg-base-100 shrink-0">
        <Link
          to={PORTAL_ROUTES.CONVERSATIONS}
          className="btn btn-ghost btn-sm btn-circle lg:hidden"
        >
          <ArrowLeft size={20} />
        </Link>

        <Skeleton className="w-10 h-10 rounded-full shrink-0" />
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-4 w-36 max-w-full rounded" />
          <Skeleton className="h-3 w-28 max-w-full rounded" />
        </div>
      </div>
    )

  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-base-200 bg-base-100 shrink-0">
      <Link
        to={PORTAL_ROUTES.CONVERSATIONS}
        className="btn btn-ghost btn-sm btn-circle lg:hidden"
      >
        <ArrowLeft size={20} />
      </Link>
      <div className="w-10 h-10 rounded-full bg-teamcare-blue text-white flex items-center justify-center text-sm font-bold shrink-0">
        {getInitials(title)}
      </div>

      <div className="min-w-0">
        <p className="text-sm font-semibold text-secondary-900 truncate">{title}</p>
        <div className="flex items-center gap-1 text-xs text-base-content/50 mt-0.5">
          <Phone size={11} />
          {patient_number}
        </div>
      </div>
    </div>
  );
}

export default Header;
